import { api } from '../api-client.config';

export const uploadFiles = async (
  files: File[],
  prefix = ''
): Promise<{ urls: string[] }> => {
  const formData = new FormData();

  files.forEach((file) => {
    formData.append('files', file);
  });

  if (prefix) {
    formData.append('prefix', prefix);
  }

  return api.post('/files/upload', formData);
};
